import { Component, OnInit, Input } from '@angular/core';
import { ShoppingCartItem } from '../../_models/cart/shopping.cart.item';
import { MainService } from '../../_services/main.service';
import { CartService } from '../../_services/cart.service';

@Component({
  selector: 'app-item-count-wide',
  templateUrl: './item-count-wide.component.html',
  styleUrls: ['./item-count-wide.component.scss']
})
export class ItemCountWideComponent implements OnInit {
  @Input() sci: ShoppingCartItem;
  @Input() center: boolean;
  @Input() right: boolean;
  @Input() isCart: boolean;

  constructor(
    public mainService: MainService,
    public cartService: CartService
  ) { }
  ngOnInit() {

  }

  getPerQuantity(): number {
    if (this.sci?.ItemInfo?.Price?.SalesUnit > 1) {
      return this.sci.ItemInfo.Price.SalesUnit;
    }
    return 1;
  }

}
